import { render, staticRenderFns } from "./PermissionGroup.vue?vue&type=template&id=bd706398&scoped=true&"
import script from "./PermissionGroup.vue?vue&type=script&lang=js&"
export * from "./PermissionGroup.vue?vue&type=script&lang=js&"
import style0 from "./PermissionGroup.vue?vue&type=style&index=0&id=bd706398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd706398",
  null
  
)

export default component.exports